import { z } from "zod";

export const siteDsoStatusDtoSchema = z.object({
  siteId: z.number(),
  historicLoadCurveReceptionDatetime: z.coerce.date().nullable(),
  historicIndexReceptionDatetime: z.coerce.date().nullable(),
  dailyLoadCurveLastReceptionDatetime: z.coerce.date().nullable(),
  dailyIndexLastReceptionDatetime: z.coerce.date().nullable(),
});

export type TSiteDsoStatusDto = z.infer<typeof siteDsoStatusDtoSchema>;
